<template>
  <v-tooltip
    bottom>
    <template
      v-slot:activator="{ on, attrs }">

      <v-btn
        v-bind="attrs"
        v-on="on"
        :color="color"
        :min-width="minWidth"
        :outlined="outlined"
        :rounded="rounded"
        :text="text"
        elevation="0"
        @click="onFindButtonClick"
        small>
        運賃計算
        <v-icon>mdi-cash-marker</v-icon>
      </v-btn>

    </template>

    <!-- RAW形式で文字列展開 -->
    <span v-html="message"></span>

  </v-tooltip>
</template>
<script>
/**
 * @file DDv2用ツールチップ付きアイコンボタン
 * @namespace components
 */

/**
 * @vue-prop {String} [message=''] - ツールチップメッセージ
 * @vue-prop {String} [icon=''] - アイコン指定
 * @vue-event {Element} click - クリックイベント
 * @see https://vuetifyjs.com/ja/api/v-icon/
 * @see https://vuetifyjs.com/ja/api/v-tooltip/
 * @description message引数はRAW形式で、タグの挿入を許可しているため、指定する際は注意すること
 * @example
 *   <dd-icon-button-with-tooltip
        v-if="item.delFlg == false"
        message="この行のコピーを作成します"
        icon="mdi-content-copy"
        @click="copyMeisaiRow(item)"/>
 */
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'

export default {
  mixins: [flowMixin],
  name: 'DdCalcTankaButton',
  props: {
    message: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    minWidth: {
      type: Number,
      default: 80
    },
    outlined: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: true
    },
    text: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * 発着地単価取得用パラメータ
     */
    searchDate: {
      type: String,
      default: filter.dateFormatter(new Date())
    },
    tankahyoKbn: {
      type: String,
      default: '10'
    },
    tankahyoDetailKbn: {
      type: String,
      default: '01'
    },
    torihikisakiCd: String,
    hatsuchiCd: String,
    chakuchiCd: String,
    hatsuChikuCd: String,
    chakuChikuCd: String,
    hatsuChimeiCd: String,
    chakuChimeiCd: String,
    kyori: String,
    suryo: String,
    juryo: String,
    unchinShashuSbt: String,
    hinshuSbt: String,
    hinmeiCd: String,
    nisugataSbt: String,
    eigyoshoCd: String,
    sharyoId: String
  },
  methods: {
    onFindButtonClick: function (e) {
      this.clearSummaryMessage()

      const rec = {
        searchDate: this.searchDate,
        tankahyoKbn: this.tankahyoKbn,
        tankahyoDetailKbn: this.tankahyoDetailKbn,
        hatsuchiCd: this.hatsuchiCd,
        chakuchiCd: this.chakuchiCd,
        torihikisakiCd: this.torihikisakiCd,
        hatsuChikuCd: this.hatsuChikuCd,
        chakuChikuCd: this.chakuChikuCd,
        hatsuChimeiCd: this.hatsuChimeiCd,
        chakuChimeiCd: this.chakuChimeiCd,
        kyori: [undefined, null, 'undefined', 'null', ''].includes(this.juryo) ? null : this.kyori,
        suryo: [undefined, null, 'undefined', 'null', ''].includes(this.juryo) ? null : this.suryo,
        juryo: [undefined, null, 'undefined', 'null', ''].includes(this.juryo) ? null : this.juryo,
        unchinShashuSbt: this.unchinShashuSbt,
        hinshuSbt: this.hinshuSbt,
        hinmeiCd: this.hinmeiCd,
        nisugataSbt: this.nisugataSbt,
        eigyoshoCd: this.eigyoshoCd,
        sharyoId: [undefined, null, 'undefined', 'null', ''].includes(this.sharyoId) ? null : this.sharyoId
      }
      this.HttpClient.post('/api/v1/mstHacchakuchiTanka/GetHacchakuchiTanka', rec)
        .then((data) => {
          if (data.isValid) {
            const hacchakuchiTankaInfo = data.payload
            if (hacchakuchiTankaInfo.tankahyoCd) {
              this.$emit('set', hacchakuchiTankaInfo)
            } else {
              this.setInvalidSummaryMessage('COMI0101')
            }
          } else {
            this.setInvalidSummaryMessage('COMI0101')
          }
        })
    }
  }
}
</script>
